module.exports = __webpack_public_path__ + "static/media/heart-bg-red.bcdbc9f8.svg";